import { render, staticRenderFns } from "./IconShield.vue?vue&type=template&id=af9cea60&"
import script from "./IconShield.vue?vue&type=script&lang=ts&"
export * from "./IconShield.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports